import Vue from 'vue'
import {
  Button,
  Image,
  Popover,
  ShareSheet,
  Field,
  Form,
  Popup,
  Icon,
  Loading,
  Dialog,
  DropdownMenu,
  DropdownItem,
  NoticeBar,
  Swipe,
  SwipeItem,
  Tabbar,
  TabbarItem,
  Tab,
  Tabs,
  CountDown,
  Uploader,
  Row,
  DatetimePicker,
  RadioGroup,
  Radio,
  Skeleton,
  ImagePreview,
  Progress,
  Overlay,
  Search,
  Cascader,
  Calendar,
} from 'vant'
import { setVariable } from '@/utils/exportVariable'
import { setAxios } from '@/utils/request'
import { locale, hackGameDefaultLanguage } from '@/utils/utils'
import { LanguageRedirection } from '@/utils/local-i18n'
import * as filters from '@/filters'
import mixins from '@/mixins'
export default (context) => {
  const { app, store } = context

  // global variable
  setVariable('store', context.store)
  setVariable('context', context)
  setVariable('i18n', app.i18n)

  let Languages = LanguageRedirection()

  Languages = hackGameDefaultLanguage(context, Languages)
  // i18n
  if (Languages) {
    app.i18n.setLocale(Languages)
  } else {
    app.i18n.setLocale(locale() || process.env.VUE_APP_I18N_LOCALE || 'br') // 设置地区
  }

  // axios
  setAxios(app.$axios, app.i18n, store)

  // filters
  Object.keys(filters).forEach((filter) => Vue.filter(filter, filters[filter]))

  // mixins
  if (!Vue.__universal_mixin__) {
    Vue.__universal_mixin__ = true
    Vue.mixin(mixins)
  }

  // vant
  Vue.use(Overlay)
  Vue.use(Progress)
  Vue.use(Button)
  Vue.use(Image)
  Vue.use(Popover)
  Vue.use(ShareSheet)
  Vue.use(Field)
  Vue.use(Form)
  Vue.use(Popup)
  Vue.use(Icon)
  Vue.use(Loading)
  Vue.use(Dialog)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  Vue.use(NoticeBar)
  Vue.use(Swipe)
  Vue.use(SwipeItem)
  Vue.use(Tabbar)
  Vue.use(TabbarItem)
  Vue.use(Tab)
  Vue.use(Tabs)
  Vue.use(CountDown)
  Vue.use(Uploader)
  Vue.use(Row)
  Vue.use(DatetimePicker)
  Vue.use(RadioGroup)
  Vue.use(Radio)
  Vue.use(Skeleton)
  Vue.use(ImagePreview)
  Vue.use(Search)
  Vue.use(Cascader)
  Vue.use(Calendar)
}
